import { AppProps } from 'next/app';
import Head from 'next/head';
import { Inter } from 'next/font/google';
import '../styles/globals.css';

const inter = Inter({ subsets: ['latin'] });

export default function MyApp({ Component, pageProps }: AppProps) {
  // Verificar se estamos em uma rota de corretores ou admin
  const isBrokerRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/brokers');
  const isAdminRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  const isAdminLoginRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin/login');
  
  // Definir títulos e descrições com base na rota
  let title = 'Encontre um corretor - Darwin Seguros';
  let description = 'API de Engajamento desenvolvida pelo time de Marketing da Darwin Seguros';
  
  if (isBrokerRoute) {
    title = 'Cadastro de Corretores | Darwin';
    description = 'Cadastro de corretores parceiros da Darwin Seguros';
  } else if (isAdminLoginRoute) {
    title = 'Login Backoffice | Darwin';
    description = 'Acesso ao backoffice de corretores da Darwin Seguros';
  } else if (isAdminRoute) {
    title = 'Backoffice Corretores | Darwin';
    description = 'Backoffice para gestão de corretores da Darwin Seguros';
  }
  
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <meta name="bingbot" content="noindex, nofollow" />
        <meta name="google" content="nositelinkssearchbox" />
        <meta name="google" content="notranslate" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className={`${inter.className} bg-gradient-to-b from-gray-50 to-gray-100`}>
        <Component {...pageProps} />
      </div>
    </>
  );
} 